import type { ErrorState } from '../../types';

/**
 * Port of `commonComponents/errorModel.jsx` — the generic error dialog.
 *
 * It reads `errorResponse?.message?.errorMessage`, which is why the odd nested shape
 * `getErrorMessage` produces for a 401 matters (see utils/errorMessage.ts). The unused
 * `loggedUserDetails` prop the original accepted is dropped; it was never read.
 */
export function ErrorModel({
  errorResponse,
  hide,
}: {
  errorResponse: ErrorState;
  hide: () => void;
}): JSX.Element {
  const modelStyle = {
    display: 'block',
    backgroundColor: 'rgba(0,0,0,0.8)',
  } as const;

  return (
    <>
      <div>
        <div className="modal show " style={modelStyle}>
          <div className="modal-dialog modal-width">
            <div className="modal-content">
              <div className="modal-header errorModel">
                <span> Error </span>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    hide();
                  }}
                ></button>
              </div>

              <div>
                <div className="modal-body">
                  <div className="row modal-title">
                    <div className="col-12">
                      {typeof errorResponse?.message === 'object'
                        ? errorResponse.message?.errorMessage
                        : undefined}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn modal-button" onClick={() => hide()}>
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
